import React, { useState } from 'react'
import ReactGA from 'react-ga4'
import ReactPlayer from 'react-player'
const Trailers = ({ isReleased }) => {
    const [isPlaying, setIsPlaying] = useState(false)
   

    const videoId = isReleased ? 'fta9bxmnbA0' : 'FKippZVYitA'
    const thumbnail = isReleased ? 'launch_thumb.webp' : 'trailer.png'
    const trailertitle =isReleased ? 'Launch Trailer' : 'Release Date Announcement Trailer'
    const handlePlay = () => setIsPlaying(true)


    return (
        <div className='container max-w-[1000px] mx-auto text-white mt-20 px-4 md:px-0 items-center'>
            <h2 className='text-md tracking-widest text-center my-12 md:my-40'>Trailer</h2>
            <div className=' max-w-[900px] w-[98%] p-4 mx-auto '>
                <div className='mx-auto video-container '>
                    {isPlaying ? (
                        <ReactPlayer
                        src={`https://www.youtube.com/embed/${videoId}`}
                            // src='https://www.youtube.com/watch?v=FKippZVYitA'
                            controls={true}
                            onPlay={() => setIsPlaying(true)}
                            width='100%'
                            height='100%'
                            // playing={isPlaying}
                            config={{
                                youtube: {
                                    playerVars: { showinfo: 1 },
                                },
                            }}
                            className='absolute top-0 left-0 w-full h-full'
                        />
                    ) : (
                        <>
                            <img
                                className='absolute w-full cursor-pointer brightness-90'
                                src={`${process.env.PUBLIC_URL}/assets/${thumbnail}`}
                                alt='r-type tactics release date announcement'
                                onClick={handlePlay}
                            />
                            <img
                                className='hover:scale-110 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer duration-300'
                                src={`${process.env.PUBLIC_URL}/assets/play.png`}
                                alt='play button'
                                onClick={handlePlay}
                            />
                        </>
                    )}
                </div>
                <h2 className='text-center text-white text-md mt-12'>{trailertitle}</h2>
            </div>
        </div>
    )
}

export default Trailers
